import { AgentMessageBarChart, AgentMessageLineChart, ChartData, ChartDataPoint } from "../chatModels";

export const convertServerChartToClientFormat = (
  serverMessage: AgentMessageLineChart | AgentMessageBarChart
): ChartData => {
  const timestampsSet = new Set<string>();
  const seriesArray =
    serverMessage.type === "charts.bar_chart" ? serverMessage.bars : serverMessage.lines;
  for (const series of seriesArray) {
    for (const point of series.dataPoints) {
      timestampsSet.add(point.timestamp);
    }
  }
  const timestamps = Array.from(timestampsSet).sort(
    (a, b) => new Date(a).getTime() - new Date(b).getTime()
  );
  const data: ChartDataPoint[] = timestamps.map((timestamp) =>
    seriesArray.reduce(
      (accumulator, series) => {
        const point = series.dataPoints.find((p) => p.timestamp === timestamp);
        accumulator[series.legendLabel] = point ? point.value : undefined;
        return accumulator;
      },
      { timestamp: Date.parse(timestamp) } as ChartDataPoint
    )
  );

  return {
    type: serverMessage.type === "charts.line_chart" ? "line" : "bar",
    title: serverMessage.title,
    data,
    series: seriesArray.map((series) => ({
      key: series.legendLabel,
      color: series.color,
      valueUnit: series.valueUnit,
    })),
  };
};
